import HackleCore from "../../HackleCore"
import { HackleEvent } from "../model/model"
import { UserManager } from "../user/UserManager"
import { PhoneNumber } from "./phoneNumber/PhoneNumber"
import { PropertyOperationsBuilder } from "../../../hackle/property/PropertyOperations"

export class PIIEventManager {
  static readonly PHONE_NUMBER_PROPERTY_KEY = "$phone_number"

  constructor(private readonly core: HackleCore, private readonly userManager: UserManager) {}

  setPhoneNumber(phoneNumber: PhoneNumber, timestamp: number) {
    const properties = new PropertyOperationsBuilder()
      .set(PIIEventManager.PHONE_NUMBER_PROPERTY_KEY, phoneNumber.getValue())
      .build()
    const securedEvent = properties.toSecuredEvent()

    this.track(securedEvent, timestamp)
  }

  unsetPhoneNumber(timestamp: number) {
    const properties = new PropertyOperationsBuilder().unset(PIIEventManager.PHONE_NUMBER_PROPERTY_KEY).build()
    const securedEvent = properties.toSecuredEvent()

    this.track(securedEvent, timestamp)
  }

  private track(event: HackleEvent, timestamp: number) {
    const hackleUser = this.userManager.hackleUser()

    this.core.track(event, hackleUser, timestamp)
  }
}
